
































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Util } from '@/utils/Util';
import { ClockIcon } from 'vue-feather-icons';
import { IGoal } from 'admiral-core';
import dayjs from 'dayjs';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';

interface ProgressData {
  value: number;
}

@Component({
  components: { ClockIcon },
})
export default class AgencyGoalProgress extends mixins(BaseMixin) {
  @Prop({ type: String, required: true })
  type!: 'policed' | 'custom';

  @Prop({ type: Object, required: true })
  goal!: IGoal;

  @Prop({
    type: Object,
    required: true,
    default: () => {
      return { value: 0 };
    },
  })
  value!: ProgressData;

  @Prop({
    type: Object,
    required: true,
    default: () => {
      return { value: 0 };
    },
  })
  submitted!: ProgressData;

  @Prop({
    type: Object,
    required: true,
    default: () => {
      return { value: 0 };
    },
  })
  open!: ProgressData;

  @Prop({
    type: Object,
    required: true,
  })
  openAbove!: ProgressData;

  @Prop({
    type: Object,
    required: true,
  })
  openBelow!: ProgressData;

  @Prop({
    type: Object,
    required: true,
    default: () => {
      return { value: 0 };
    },
  })
  total!: ProgressData;

  // @Prop({
  //   type: Number,
  //   required: true,
  //   default: () => 0
  // })
  // timeValue!: number;

  get valuePercent() {
    const val = (this.value.value / this.total.value) * 100;
    return isNaN(val) ? 0 : val;
  }

  get submittedPercent() {
    const val = (this.submitted.value / this.total.value) * 100;
    return isNaN(val) ? 0 : val;
  }
  get openPercent() {
    const val = (this.open.value / this.total.value) * 100;
    return isNaN(val) ? 0 : val;
  }

  get openAbove70Percent() {
    const val = (this.openAbove.value / this.total.value) * 100;
    return isNaN(val) ? 0 : val;
  }

  get openBelow70Percent() {
    const val = (this.openBelow.value / this.total.value) * 100;
    return isNaN(val) ? 0 : val;
  }

  get timeValue() {
    return Util.relativeValue(this.total.value, this.goal.from, this.goal.to);
  }

  get timeValuePercent() {
    const val = (this.timeValue / this.total.value) * 100;
    return isNaN(val) ? 0 : val;
  }

  get typeStr() {
    return this.type === 'policed' ? 'Policiert' : 'Ergebnis';
  }

  getDaysCompleted() {
    return dayjs().diff(dayjs(this.goal.from), 'day');
  }
  getDaysTotal() {
    return dayjs(this.goal.to).diff(dayjs(this.goal.from), 'day');
  }

  isGoalCompleted() {
    return this.getDaysCompleted() >= this.getDaysTotal();
  }

  get timeValueTooltip() {
    return `${Math.round(this.timeValue).toLocaleString('de-DE')} ${
      this.agency.wording?.value
    } nach ${this.getDaysCompleted()} von ${this.getDaysTotal()} Tagen`;
  }

  get valueBarPercent() {
    return this.valuePercent;
  }

  get submittedBarPercent() {
    if (this.valuePercent + this.submittedPercent > 100) {
      return 100 - this.valuePercent;
    }
    return this.submittedPercent;
  }

  get openAbove70BarPercent() {
    if (this.valuePercent + this.submittedPercent + this.openAbove70Percent > 100) {
      return 100 - this.valuePercent - this.submittedPercent;
    }
    return this.openAbove70Percent;
  }

  get openBelow70BarPercent() {
    if (
      this.valuePercent +
        this.submittedPercent +
        this.openAbove70Percent +
        this.openBelow70Percent >
      100
    ) {
      return 100 - this.valuePercent - this.submittedPercent - this.openAbove70Percent;
    }
    return this.openBelow70Percent;
  }
}
